import SearchView from '@app/Search/View'
import KnowledgeBaseSearch from '@app/Search/KnowledgeBaseSearch'

export default function install(Vue) {
  Vue.component(SearchView.name, SearchView)
  Vue.component(KnowledgeBaseSearch.name, KnowledgeBaseSearch)
}
